export default Object.freeze({
  Task: 1, // "task"
  CompleteInformation: 2, // "complete-information"
  Approval: 3, // "approval"
  ExecuteTask: 4, // "execute-task"
  DigitalSignature: 5, // "digital-signature"
});
